import { render, staticRenderFns } from "./AiBotPopup.vue?vue&type=template&id=4e19f0aa&scoped=true&"
import script from "./AiBotPopup.vue?vue&type=script&lang=js&"
export * from "./AiBotPopup.vue?vue&type=script&lang=js&"
import style0 from "./AiBotPopup.vue?vue&type=style&index=0&id=4e19f0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19f0aa",
  null
  
)

export default component.exports